import { registerComponent, triggerEvent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "customizer-brickmoulds",
  class CustomizerBrickmoulds extends WYATTElement {
    constructor() {
      super();

      this.values = this.querySelectorAll('[name="brickmould"]');
      this.optionsGroup = this.querySelector("[data-options]");
      this.removeNailFin = this.optionsGroup.querySelector(
        '[data-option="remove_nail_fin"]',
      );

      this.setup();

      this.values.forEach((value) =>
        value.addEventListener("change", this.toggleOptions.bind(this)),
      );
    }

    setup() {
      const value = this.closest(
        "wyatt-customizer, wyatt-customizer-mulled",
      ).formData.get("brickmould");

      if (this.config.showFor.includes(value)) {
        this.optionsGroup.removeAttribute("hidden");
      } else {
        this.optionsGroup.setAttribute("hidden", "");
      }
    }

    toggleOptions(event) {
      const { value } = event.target;

      if (this.config.showFor.includes(value)) {
        this.optionsGroup.removeAttribute("hidden");
      } else {
        this.optionsGroup.setAttribute("hidden", "");
        this.removeNailFin.checked = false;
        triggerEvent(this.removeNailFin, "change");
      }
    }
  },
);
